import "./styles/global.css";
import "./styles/pages/login.css";
import { startBrowserProtectedEntry } from "./auth/protectedEntry.js";
import { loadProtectedProject } from "./routing/protectedProjectLoad.js";

const protectedRoot = document.getElementById("session-protected-root");
const neutralRoot = document.getElementById("session-neutral-root");
if (!protectedRoot || !neutralRoot)
  throw new Error("board entry: session roots are missing");

async function prepareProtectedTransport(): Promise<void> {
  if (import.meta.env.VITE_USE_MSW !== "true") return;
  try {
    const { worker } = await import("./mocks/browser.js");
    await worker.start({ onUnhandledRequest: "bypass" });
    // eslint-disable-next-line no-console
    console.info("GoCanvas: MSW mock server started");
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("GoCanvas MSW init failed, continuing without mocks:", error);
  }
}

startBrowserProtectedEntry({
  protectedRoot,
  neutralRoot,
  load: () => loadProtectedProject({
    location: globalThis.location,
    apiBase: import.meta.env.VITE_API_BASE ?? "/api",
    basePath: import.meta.env.BASE_URL || "/",
    prepareTransport: prepareProtectedTransport,
    importProduct: () => import("./main.js"),
  }),
});
